import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { OverviewSection } from "./components/OverviewSection";
import { ServicesSection } from "./components/ServicesSection";
import { WhyChooseSection } from "./components/WhyChooseSection";
import { ProcessSection } from "./components/ProcessSection";
import { PricingSection } from "./components/PricingSection";
import { IndustriesSection } from "./components/IndustriesSection";
import { BenefitsSection } from "./components/BenefitsSection";
import { TrustSection } from "./components/TrustSection";
import { FAQSection } from "./components/FAQSection";
import { CTASection } from "./components/CTASection";
import { ContactSection } from "./components/ContactSection";
import { ContactPopup } from "./components/ContactPopup";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsConditions } from "./pages/TermsConditions";
import { ScrollToTop } from "./components/ScrollToTop";

const HomePage = ({ onContactClick }) => {
  return (
    <>
      <Helmet>
        <title>Professional Trademark Registration Services | TradeMark Registry</title>
        <meta name="description" content="Expert trademark registration services with 95% success rate. Professional USPTO filing, comprehensive searches, and brand protection. Affordable packages starting at $45. Protect your brand today!" />
        <meta name="keywords" content="trademark registration, USPTO filing, trademark search, brand protection, trademark attorney, register trademark, trademark application, intellectual property, trademark services" />
        <meta property="og:title" content="Professional Trademark Registration Services | TradeMark Registry" />
        <meta property="og:description" content="Expert trademark registration services with 95% success rate. Professional USPTO filing, comprehensive searches, and brand protection." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Professional Trademark Registration Services | TradeMark Registry" />
        <meta name="twitter:description" content="Expert trademark registration services with 95% success rate. Professional USPTO filing, comprehensive searches, and brand protection." />
        <link rel="canonical" href="https://trademark-pro-8.preview.emergentagent.com/" />
      </Helmet>
      <HeroSection onContactClick={onContactClick} />
      <AboutSection />
      <OverviewSection />
      <ServicesSection />
      <WhyChooseSection />
      <ProcessSection />
      <PricingSection onContactClick={onContactClick} />
      <IndustriesSection />
      <BenefitsSection />
      <TrustSection />
      <FAQSection />
      <CTASection onContactClick={onContactClick} />
      <ContactSection onContactClick={onContactClick} />
    </>
  );
};

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleContactClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App min-h-screen bg-white">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header onContactClick={handleContactClick} />
                  <main>
                    <HomePage onContactClick={handleContactClick} />
                  </main>
                  <Footer onContactClick={handleContactClick} />
                  <ContactPopup isOpen={isPopupOpen} onClose={handleClosePopup} />
                  <Toaster />
                </>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
